/**
 * Shared helpers untuk bulk input model (dashboard superadmin AI Gateway).
 *
 * Dipakai di:
 *   - dashboard/src/App.tsx  → parse input text user sebelum kirim mutation
 *   - convex/dashboard.ts    → merge chain existing + tambahan (dedupe in-order)
 *   - scripts/probe-model-list.ts → anti-regresi
 *
 * Sumber kebenaran daftar model: `aiGatewayProviders` di DB Convex
 * (DI-SIMPAN KE DB, bukan hardcode). `mergeModelChain` menyatukan katalog
 * provider dengan model yang dipakai — chain rotasi global-nya sendiri
 * ({ provider, model }) dibangun `buildChainFromProviders` / dipangkas
 * `normalizeChainEntries`, lalu dirotasi `rotateChain`
 * (convex/lib/modelRotation.ts).
 */

/**
 * Split input mentah menjadi daftar model unik; urutan asli dipertahankan.
 * Separator: koma, spasi, baris baru, titik-koma, pipe (|) — masing-masing
 * satu atau lebih berturut-turut. Nama model mengandung "/" ":" "-" ":free"
 * tapi tidak pernah mengandung karakter separator, jadi split aman.
 */
export function parseModelList(raw: string): string[] {
  if (!raw) return [];
  const seen = new Set<string>();
  const out: string[] = [];
  for (const part of raw.split(/[\s,;|]+/)) {
    const model = part.trim();
    if (!model || seen.has(model)) continue;
    seen.add(model);
    out.push(model);
  }
  return out;
}

/**
 * Gabung chain existing dengan tambahan baru tanpa duplikat (in-order):
 * existing dulu utuh urutannya, tambahan baru di belakang yang belum ada.
 */
export function mergeModelChain(existing: string[], incoming: string[]): string[] {
  const seen = new Set<string>(existing);
  const merged: string[] = [...existing];
  for (const model of incoming) {
    if (!model || seen.has(model)) continue;
    seen.add(model);
    merged.push(model);
  }
  return merged;
}
